<script setup lang="ts">
import { FeatureExchangeRate } from '~/components/feature/exchange-rate'
import { LucideLoaderCircle } from 'lucide-vue-next'
import { CurrencyIcon } from '~/components/ui/currency-icon'

interface IProps {
  currency: string
  currentValue?: number
}

const props = defineProps<IProps>()
</script>

<template>
  <article class="flex items-center gap-2">
    <CurrencyIcon
      :code="currency"
      :title="`${$t('ui.exchange_rate.currency_flag_title')} ${currency}`"
      size="lg"
      class="mr-1 hidden sm:block"
    />
    <div class="flex items-center gap-0.5 uppercase">
      {{ currency }}
      <div class="flex items-center gap-2">
        <FeatureExchangeRate
          v-if="props.currentValue"
          :current-value="props.currentValue"
          :currency-id="useGetCurrencyIdByCode(props.currency) || 0"
        />
        <LucideLoaderCircle v-else class="mt-1 size-4 animate-spin sm:ml-3 sm:mt-0" />
      </div>
    </div>
  </article>
</template>
